import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import moment from "moment";
import React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { Col, Container, Row } from "reactstrap";
import constants from "../../../utils/constants";
import { handleRequestError } from "../../../utils/helpers";
import {
  infoNotification,
  successNotification
} from "../../../utils/notifications";
import { getConciliacionCalendarUploadedFiles } from "../../actions/billing";
import { YearComponent } from "../common/calendar/YearComponent";
import s from "./styles.scss";

interface Props extends RouteComponentProps {}

interface State {
  calendarLoading: boolean;
  calendarView: boolean;
  submitter: any;
  selected: {
    fecha: string;
    tipoAfiliacion: "ORIGINAL" | "ALTERNA";
  }[];
  year: number;
}

class ConciliacionCalendarUploadedFiles extends React.Component<Props, State> {
  state = {
    calendarLoading: false,
    calendarView: false,
    year: moment().year(),
    submitter: {} as any,
    selected: []
  };

  async componentDidMount() {
    this.getUploadedFilesCalendar(this.state.year || moment().year());
  }

  getUploadedFilesCalendar(year: number) {
    infoNotification("Consultando datos de archivos cargados");
    this.setState({ calendarLoading: true, calendarView: false, selected: [] });

    getConciliacionCalendarUploadedFiles(year)
      .then(({ data }) => {
        successNotification("Datos obtenidos correctamente");

        data.fechas.forEach(element => {
          element.fecha = element.fechaArchivo;
          element.tipoAfiliacion = "ORIGINAL";
          element.onClick = () => {
            if (!!element.fileStorageId) {
              window.open(
                `${constants.BASE_URL}/${constants.DOCUMENTS_BASE_URL}/${element.fileStorageId}`,
                "_blank"
              );
            }
          };
        });

        this.setState({
          selected: data.fechas || [],
          calendarLoading: false,
          calendarView: true
        });
      })
      .catch(handleRequestError);
  }

  /**
   * Renderizado del calendario, cuando aplica
   */
  renderCalendar() {
    if (this.state.calendarLoading) {
      return (
        <div style={{ textAlign: "center" }}>
          Espere un momento por favor <br />
          <span style={{ fontSize: "1.4em" }}>
            <FontAwesomeIcon icon={faSpinner} pulse />
          </span>
        </div>
      );
    } else if (this.state.calendarView) {
      return (
        <div style={{ textAlign: "center" }}>
          <YearComponent
            id={+"UploadedFilesCalendar-" + this.state.year}
            year={this.state.year}
            submitter={this.state.submitter}
            selected={this.state.selected}
            onChangeYear={() => {}}
            soportaAlterna={false}
          />
        </div>
      );
    } else {
      return null;
    }
  }

  render() {
    return (
      <Container>
        {/* Selector de tipo de cargo (TDD, TDC o AMEX) */}
        <div className="calendar-labels-container">
          <Row>
            <div className="col-7" style={{ paddingTop: "20px" }}>
              <div
                className="sw-calendar date selected afiliacion-original"
                style={{ marginLeft: "16px", pointerEvents: "none" }}
              >
                &nbsp;
              </div>
              <div style={{ display: "inline-block", fontSize: "0.8rem" }}>
                Archivos cargados
              </div>
            </div>

            <Col xs={12}>
              <hr />
            </Col>
          </Row>
        </div>

        {/* Renderizado del calendario */}
        {this.renderCalendar()}
      </Container>
    );
  }
}

export default withRouter<Props, any>(
  withStyles(s)(ConciliacionCalendarUploadedFiles)
);
